<template>
  <v-container fluid class="pt-1">
    <v-layout column wrap>
      <customer-image class="mb-3" :file="value.photo" v-model="value.image" />
      <v-text-field
        outline
        :label="$t('name')"
        data-vv-name="name"
        v-model="value.name"
        v-validate="'required'"
        :data-vv-as="$t('name')"
        :error-messages="errors.collect('name')"
      />
      <v-text-field
        outline
        :label="$t('father_name')"
        v-model="value.father_name"
      />
      <v-combobox
        outline
        multiple
        small-chips
        :label="$t('phones')"
        v-model="value.phones"
      />
      <v-textarea
        outline
        rows="0"
        auto-grow
        :label="$t('address')"
        v-model="value.address"
      />
      <v-text-field
        outline
        class="flex xs12 sm6"
        :label="$t('nationality')"
        v-model="value.nationality"
      />
      <v-text-field
        outline
        class="flex xs12 sm6"
        :label="$t('tazkira_no')"
        v-model="value.tazkira_no"
      />
      <v-layout row wrap>
        <v-combobox
          outline
          :label="$t('gender')"
          v-model="value.gender"
          :items="['Male', 'Female']"
        />
        <div class="mx-1" />
        <v-combobox
          outline
          :label="$t('marital_status')"
          :items="['Married', 'Single']"
          v-model="value.marital_status"
        />
      </v-layout>
      <v-layout row wrap>
        <v-text-field
          outline
          auto-grow
          v-model="value.place_of_birth"
          :label="$t('place_of_birth')"
        />
        <div class="mx-1" />
        <v-text-field
          outline
          :label="$t('date_of_birth')"
          v-model="value.date_of_birth"
        />
      </v-layout>
      <v-layout row wrap justify-space-between>
        <v-date
          type="date"
          tabindex="0"
          :clearable="false"
          format="YYYY-MM-DD"
          input_id="join_date"
          v-validate="'required'"
          value-type="YYYY-MM-DD"
          data-vv-name="join_date"
          v-model="value.hire_date"
          class="flex xs12 sm6 px-1"
          :data-vv-as="$t('join_date')"
          :placeholder="$t('join_date')"
          :error-messages="errors.collect('join_date')"
        />
        <v-date
          type="date"
          tabindex="0"
          :clearable="false"
          format="YYYY-MM-DD"
          input_id="resign_date"
          value-type="YYYY-MM-DD"
          v-model="value.fire_date"
          class="flex xs12 sm6 px-1"
          :placeholder="$t('resign_date')"
        />
      </v-layout>
      <v-layout row wrap justify-space-between>
        <v-text-field
          outline
          v-model="value.salary"
          class="flex xs12 sm6 px-1"
          :label="$t('share_amount')"
        />
        <v-text-field
          outline
          class="flex xs12 sm6 px-1"
          :label="$t('share_percentage')"
          v-model="value.share_percentage"
        />
      </v-layout>
    </v-layout>
    <v-btn color="primary" class="mx-0" @click="save" :loading="loading">{{
      $t("save")
    }}</v-btn>
  </v-container>
</template>

<script>
import { customersMixin } from "@/mixins/index.js";

export default {
  props: ["value"],
  data: () => ({
    loading: false,
  }),
  mixins: [customersMixin],
  methods: {
    save() {
      this.loading = true;
      this.$validator.validateAll().then((succeed) => {
        if (succeed) {
          this.axios.post("customers", this.value).then((res) => {
            this.loading = false;
            this.value.id = res.data.data.id;
            this.$store.commit("showSnackbar", {
              text: this.$t("save_succeed"),
              stateType: "success",
              show: true,
            });
            this.getCustomers();
            this.$emit("saved", res.data.data);
          });
        } else {
          this.loading = false;
          this.$store.commit("showSnackbar", {
            text: this.$t("wrong_input"),
            stateType: "error",
            show: true,
          });
        }
      });
    },
  },
  watch: {
    value: function () {
      this.$emit("input", this.value);
    },
  },
};
</script>